"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useIsomorphicLayoutEffect = _interopRequireDefault(require("../../../../hooks/useIsomorphicLayoutEffect"));
var _useVideo = _interopRequireDefault(require("../../hooks/useVideo"));
var _provider = _interopRequireDefault(require("./provider"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var ShowHerosProvider = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _a = (0, _react.useState)(null),
    wrapperRef = _a[0],
    setWrapperRef = _a[1];
  var _b = (0, _react.useState)(false),
    isReady = _b[0],
    setIsReady = _b[1];
  var _c = (0, _useVideo.default)(),
    src = _c.src,
    config = _c.config,
    width = _c.width,
    height = _c.height,
    onReady = _c.onReady,
    onEvent = _c.onEvent;
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      _domRef: wrapperRef
    };
  }, [wrapperRef]);
  (0, _useIsomorphicLayoutEffect.default)(function () {
    if (wrapperRef) {
      var playerScript = null;
      if (src) {
        playerScript = _provider.default.initiateBySrc(src, config);
      } else if (config === null || config === void 0 ? void 0 : config.script) {
        playerScript = _provider.default.initiateByScript(config);
      }
      if (playerScript) {
        wrapperRef.innerHTML = '';
        wrapperRef.appendChild(playerScript);
        setIsReady(true);
      }
    }
  }, [config, src, wrapperRef]);
  (0, _react.useEffect)(function () {
    if (isReady) {
      onReady();
    }
  }, [isReady, onReady]);
  (0, _react.useEffect)(function () {
    if (config === null || config === void 0 ? void 0 : config.eventId) {
      var handleMessage_1 = function handleMessage_1(event) {
        var _a;
        if (((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.event_id) === config.eventId) {
          onEvent(event.data);
        }
      };
      window.addEventListener('message', handleMessage_1);
      return function () {
        window.removeEventListener('message', handleMessage_1);
      };
    }
  }, [config === null || config === void 0 ? void 0 : config.eventId, onEvent]);
  var style = {
    width: width,
    height: height
  };
  return (0, _jsxRuntime.jsx)("div", __assign({
    style: style
  }, props, {
    ref: setWrapperRef
  }));
});
var _default = ShowHerosProvider;
exports.default = _default;